import React, { useState, useEffect, useContext } from 'react'
import ApiService from '../../../services/ApiService'
import { BottomDiv, ButtonContainer, ButtonDiv, ButtonForCreateAFunction, CloseDiv, Container, FormData, Header, InputData, InputDiv, InputLabel, SelectData, SelectFucntionsDiv, TabDiv, TabsDiv, TabText } from './style'
import close from '../../../assets/close-icon.svg'
import ModalContext from '../../../contexts/ModalContext'
import { fieldsAndValues, formatOptions, getFieldsByFormat } from './utils'
import plus from '../../../assets/productions/plus.svg'
import disk from '../../../assets/productions/disk.svg'
import { MachineContext, MachineObjectType } from '../../../contexts/MachineContext'
import { functionsType } from '../../AddCompanyModal/types'

const CreateMachineModal:React.FC = () => {
  const { setModalActive, modalSection, setModalSection, setLastSection } = useContext(ModalContext)
  const [ incorrectData, setIncorrectData ] = useState<boolean>(false)
  const [ allFunctions, setAllFunctions ] = useState<functionsType[]>([])
  const { machine, setMachine } = useContext(MachineContext)
  const [ dynamicFields, setDynamicFields ] = useState(fieldsAndValues)

  useEffect(() => {

    setDynamicFields(getFieldsByFormat(machine.format))
  }, [machine.format])

  useEffect(() => {
    if (modalSection === 'editMachine') {
      const dateFields: (keyof MachineObjectType)[] = ['nextMaintenance', 'lastMaintenance']
  
      const formattedMachineData = dateFields.reduce((acc, item) => {
        const formattedDate = machine[item]
          ? new Date(machine[item]).toLocaleDateString('en-CA')
          : ''
        acc[item] = formattedDate
        return acc
      }, {} as Partial<MachineObjectType>)

  







  




    }
  }, [modalSection])

  const formatCurrency = (value: string) => {
    value = value.replace(/\D/g, '')

    const cents = value.slice(-2) || '00'
    const integerPart = value.slice(0, -2) || '0'

    return `${parseInt(integerPart, 10)},${cents.padStart(2, '0')}`
  }

  const handleInputChange = (value: string, field: string) => {
    setMachine((prevData) => ({
      ...prevData,
      [field]: value
    }))
  }

  const handleSubmit = async () => {







    setIncorrectData(false)

    const formattedData = {
      ...machine,
      costPerHour: Number(machine.costPerHour.replace(',', '.')),
      weight: Number(machine.weight),
      length: Number(machine.length),
      height: Number(machine.height),
      width: Number(machine.width),
      productionCapacityMin: Number(machine.productionCapacityMin),
      productionCapacityMax: Number(machine.productionCapacityMax),
    }

    try {
      if(!machine.id) {
        await ApiService.productionFlow.createMachine(test)
      } else {
        await ApiService.productionFlow.updateMachine(machine.id!, test)
      }

    } catch (error) {
      console.error(error)
    }
  }

  const handleGetAllFunctions = () => {
    ApiService.productionFlow.getFunctions()
      .then((response: any) => {
        setAllFunctions(response.data)
      })
      .catch((error: any) => {
        console.log(error)
      })

  }
  
  return(
    <Container>
      <Header>
      <h2>{modalSection === 'editMachine' ? `Máquina: ${machine.identification}` : 'Cadastrar máquina'}</h2>
      <CloseDiv onClick={() => (setModalActive(false))}>
        <img src={close} />
      </CloseDiv>
      </Header>
      <FormData>
        {dynamicFields.map((item, index) => (
          <InputDiv key={index}>
            <InputLabel>{item.label}</InputLabel>
            {item.type === 'select' ? (
              item.value === 'unitOfMeasure' ? (
                <SelectData value={machine.unitOfMeasure} onChange={(e) => setMachine((prev:any) => ({
                  ...prev,
                  unitOfMeasure: e.target.value
                }))}>
                  <option value=''>Selecione</option>
                  <option value='mm'>Milímetro</option>
                  <option value='cm'>Centímetro</option>
                  <option value='m'>Metro</option>
                  <option value='kg'>Quilograma</option>
                </SelectData>
              ) : item.value === 'format' ? (
                <SelectData value={machine.format} onChange={(e) => setMachine((prev:any) => ({
                  ...prev,
                  format: e.target.value
                }))}>
                  <option value=''>Selecione</option>
                  {formatOptions.map((format, formatIndex) => 
                    <option value={format.value} key={formatIndex}>{format.label}</option>
                  )}
                </SelectData>
              ) : null
            ):(
              <InputData
                type={item.type}
                placeholder={item.placeholder ? item.placeholder : 'Digite aqui'}
                onChange={(event) => {
                  let value = event.target.value
                  if (item.type === 'cash') {
                    value = formatCurrency(value)
                  }
                  handleInputChange(value, item.value)
                  event.target.value = value
                }}
                value={machine[item.value as keyof typeof machine]}
              />
            )}
          </InputDiv>
        ))}
        <InputDiv>
          <InputLabel>Funções</InputLabel>
          <SelectData value='' onFocus={handleGetAllFunctions} onChange={(e) => setMachine((prev:any) => {
            const functionId = Number(e.target.value)
            const isRepeated = prev.functions.filter((f:any) => f.id == functionId)
            if(isRepeated.length > 0) return prev
            const functionObject = allFunctions.filter(f => f.id == functionId)
            return {
              ...prev,
              functions:[...prev.functions, functionObject[0]]
            }
          })}>
            <option value=''>Selecione</option>
            {allFunctions.map((item, index) => 
              <option value={item.id} key={index}>{item.name}</option>
            )}
          </SelectData>
          <TabsDiv>
            {machine.functions.map((machineObj, machineIndex) => (
              <TabDiv key={machineIndex}>
                <TabText>{machineObj.name}</TabText>
                <img
                  src={close}
                  alt="close icon"
                  onClick={() => 
                    setMachine((prev:any) => ({
                      ...prev,
                      functions: prev.functions.filter((_:string, index:number) => index !== machineIndex)
                    }))
                  }
                />
              </TabDiv>
            ))}
          </TabsDiv>
          <ButtonForCreateAFunction
            onClick={() => {
              setModalActive(true)
              setModalSection('createNewFunction')
              setLastSection('createMachine')
            }}
          >
            + Criar função
          </ButtonForCreateAFunction>
        </InputDiv>
      </FormData>
      <BottomDiv>
        <span>{incorrectData === true && <>Preencha todos os campos</>}</span>
        <ButtonContainer>
          <ButtonDiv onClick={() => setModalActive(false)} className='cancel'>Cancelar</ButtonDiv>
          <ButtonDiv onClick={() => handleSubmit()}>
            <img src={modalSection === 'createMachine' ? plus : disk} /> 
            {modalSection === 'createMachine' ? 'Cadastrar' : 'Salvar alterações'}
          </ButtonDiv>
        </ButtonContainer>
      </BottomDiv>
    </Container>
  )
}

export default CreateMachineModal
